var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIconDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.5535H4M4 20.5535H10M4 20.5535V12.0057C4 11.4713 4 11.204 4.06497 10.9554C4.12255 10.7351 4.21779 10.5265 4.3457 10.3381C4.49004 10.1255 4.69064 9.94916 5.09277 9.59729L9.89436 5.39591C10.6398 4.74361 11.0126 4.41744 11.4324 4.29329C11.8026 4.18381 12.1972 4.18381 12.5674 4.29329C12.9875 4.41753 13.3608 4.74401 14.1074 5.39729L18.9074 9.59729C19.3095 9.94915 19.5102 10.1255 19.6546 10.3381C19.7825 10.5265 19.877 10.7351 19.9346 10.9554C19.9995 11.204 20 11.4713 20 12.0057V20.5535M10 20.5535H14M10 20.5535V16.5535C10 15.449 10.8954 14.5535 12 14.5535C13.1046 14.5535 14 15.449 14 16.5535V20.5535M14 20.5535H20M20 20.5535H22",
    stroke: "#0C056D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconDashboard);
export default __webpack_public_path__ + "static/media/NavIconDashboard.f6dc67aeea8840df03694c6df600a90e.svg";
export { ForwardRef as ReactComponent };